module.exports = __webpack_public_path__ + "img/advantage-1.af5dac85.png";